export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/9ad2d006b2e4ff9d6346e9250413d002.jpg"
          alt="Hero Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 py-32">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="text-center lg:text-left">
            <h1 className="text-5xl lg:text-7xl font-bold text-white leading-tight mb-6">
              Build Your Digital Presence
            </h1>
            <p className="text-lg lg:text-xl text-gray-200 mb-8 leading-relaxed">
              Professional website design and SEO services that drive results. We create stunning, high-performing websites optimized for search engines and conversions.
            </p>
            <button
              onClick={scrollToContact}
              className="bg-[#FF6B6B] text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-[#FF5252] transition-all inline-flex items-center gap-2 whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl"
            >
              Start Your Project
              <i className="ri-arrow-right-line text-xl"></i>
            </button>
          </div>

          <div className="hidden lg:grid grid-cols-2 gap-4">
            <div className="space-y-4">
              <div className="bg-white/10 backdrop-blur-md rounded-3xl p-4 hover:transform hover:scale-105 transition-all">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20responsive%20website%20design%20mockup%20on%20laptop%20screen%2C%20clean%20professional%20interface%2C%20e-commerce%20layout%2C%20minimalist%20design%2C%20white%20background%2C%20high%20quality%20product%20photography%20style&width=400&height=300&seq=portfolio-001&orientation=landscape"
                  alt="Portfolio Example 1"
                  className="w-full h-48 object-cover object-top rounded-2xl"
                />
              </div>
              <div className="bg-white/10 backdrop-blur-md rounded-3xl p-4 hover:transform hover:scale-105 transition-all">
                <img
                  src="https://readdy.ai/api/search-image?query=Corporate%20business%20website%20design%20on%20tablet%20device%2C%20professional%20layout%2C%20modern%20UI%20elements%2C%20clean%20white%20background%2C%20premium%20quality%20showcase&width=400&height=300&seq=portfolio-002&orientation=landscape"
                  alt="Portfolio Example 2"
                  className="w-full h-48 object-cover object-top rounded-2xl"
                />
              </div>
            </div>
            <div className="space-y-4 pt-8">
              <div className="bg-white/10 backdrop-blur-md rounded-3xl p-4 hover:transform hover:scale-105 transition-all">
                <img
                  src="https://readdy.ai/api/search-image?query=Restaurant%20website%20design%20on%20mobile%20phone%2C%20elegant%20food%20photography%2C%20modern%20app%20interface%2C%20clean%20white%20background%2C%20professional%20presentation&width=400&height=300&seq=portfolio-003&orientation=landscape"
                  alt="Portfolio Example 3"
                  className="w-full h-48 object-cover object-top rounded-2xl"
                />
              </div>
              <div className="bg-white/90 backdrop-blur-md rounded-3xl p-6 shadow-xl">
                <div className="text-center">
                  <div className="text-4xl font-bold text-[#FF6B6B] mb-2">500+</div>
                  <div className="text-sm font-medium text-gray-700">Websites Launched</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-white"></i>
      </div>
    </section>
  );
}
